/* Polsk katalog for locale-advisor-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'adv.cf.cashBasisMissing': 'Dane o środkach pieniężnych są niedostępne. Salda i ruchy muszą dać się uzgodnić z księgą główną.',
  'adv.cf.cashBalanceEvidence': 'Zaksięgowane saldo kasy i banku wynosi {amount}. Nie jest to saldo potwierdzone przez bank.',
  'adv.rpt.period.profit': 'W {quarter}. kwartale {year} przychody wynoszą {income}, a zysk {result}.',
  'adv.rpt.period.loss': 'W {quarter}. kwartale {year} przychody wynoszą {income}, a strata {result}.',
  'adv.rpt.period.nativeSuppliers': 'Lista dostawców obejmuje datowane zakupy w kwartale, bez środków trwałych i importowanych podsumowań rocznych bez podziału na kwartały.',
  'adv.rpt.period.choose': 'Okres',
  'adv.rpt.period.year': 'Cały rok',
  'adv.rpt.period.yearLabel': 'Cały rok {year}',
  'adv.rpt.period.quarter': '{quarter}. kwartał',
  'adv.rpt.period.label': '{quarter}. kwartał {year}',
  'adv.rpt.period.vsQuarter': 'względem tego samego kwartału poprzedniego roku',
  'adv.rpt.period.quarterBasis': 'Dane księgowe za {from}–{to}. Bilans pokazuje saldo na koniec okresu.',
  'adv.rpt.period.currentStatus': 'Status działań następczych w momencie wygenerowania raportu {date}. Ta część korzysta z bieżących otwartych pozycji i przeglądu rocznego, a nie z historycznego statusu na koniec kwartału.',
  'adv.rpt.period.rolling': 'Kroczące 12 miesięcy do {to} w porównaniu z poprzednimi 12 miesiącami.',
  'adv.rpt.period.nativeSales': 'Szczegóły klientów i faktur obejmują zaksięgowane faktury z datą w kwartale. Importowane podsumowania roczne bez podziału na kwartały nie są tu uwzględnione.',
  'adv.rpt.period.budget': 'Kwoty zaksięgowane w wybranym kwartale są porównywane z budżetem na te same trzy miesiące.',
  'adv.rpt.period.pdfUnavailable': 'Nowy układ PDF nie jest jeszcze dostępny na serwerze. Spróbuj ponownie po aktualizacji.',
  'adv.rpt.slides.present': 'Prezentuj',
  'adv.rpt.slides.exit': 'Zakończ prezentację',
  'adv.rpt.slides.readable': 'Czytaj tekst strony',
  'adv.rpt.slides.previous': 'Wstecz',
  'adv.rpt.slides.next': 'Dalej',
  'adv.rpt.slides.page': 'Strona {current} z {total}',
  'adv.rpt.modal.title': 'Utwórz raport',
  'adv.rpt.modal.intro': 'Wybierz szablon raportu. SuperPlumma pobiera dane z Twojej księgowości i przygotowuje szkic, który możesz przejrzeć przed udostępnieniem.',
  'adv.rpt.modal.generate': 'Wygeneruj raport',
  'adv.rpt.modal.cancel': 'Anuluj',
  'adv.rpt.modal.basis': 'Źródła danych: {sources}',
  'adv.rpt.modal.year': 'Rok obrotowy',
  'adv.rpt.modal.saved': 'Zapisane raporty',
  'adv.rpt.modal.savedEmpty': 'Nie masz jeszcze zapisanych raportów.',
  'adv.rpt.modal.open': 'Otwórz',
  'adv.rpt.modal.delete': 'Usuń',
  'adv.rpt.modal.deleted': 'Raport został usunięty.',
  'adv.rpt.hero.cta': 'Utwórz raport',
  'adv.rpt.saved.title': 'Zapisane raporty',
  'adv.rpt.saved.tab': 'Zapisane raporty',
  'adv.rpt.saved.description': 'Zapisane raporty pozostają jako migawki i nie zmieniają się po aktualizacji księgowości.',
  'adv.rpt.saved.count': 'Zapisane raporty: {count} z {limit}',
  'adv.rpt.saved.limitError': 'Możesz zapisać maksymalnie {limit} raportów. Usuń raport, zanim zapiszesz nowy.',
  'adv.rpt.saved.loading': 'Wczytywanie zapisanych raportów …',
  'adv.rpt.saved.emptyTitle': 'Brak zapisanych raportów',
  'adv.rpt.saved.emptyText': 'Utwórz raport i zapisz go, gdy chcesz zachować dokładnie tę wersję.',
  'adv.rpt.saved.loadFailed': 'Nie udało się wczytać zapisanych raportów.',
  'adv.rpt.saved.deleteFailed': 'Nie udało się usunąć raportu.',
  'adv.rpt.tpl.styre.name': 'Raport dla zarządu i kierownictwa',
  'adv.rpt.tpl.styre.desc': 'Kompleksowy raport dla zarządu z wynikiem, płynnością, ryzykami i zalecanymi działaniami.',
  'adv.rpt.tpl.manedsrapport.name': 'Raport miesięczny',
  'adv.rpt.tpl.manedsrapport.desc': 'Stan za wybrany miesiąc z budżetem, porównaniem z poprzednim rokiem, trendem i zalecanymi kolejnymi krokami.',
  'adv.rpt.tpl.likviditet.name': 'Raport płynności',
  'adv.rpt.tpl.likviditet.desc': 'Otwarte pozycje, bufor i bieżące saldo na podstawie zaksięgowanych danych.',
  'adv.rpt.tpl.avvik.name': 'Raport wyniku i odchyleń',
  'adv.rpt.tpl.avvik.desc': 'Największe odchylenia od budżetu od początku roku oraz pozycje kosztowe, które zmieniły się najbardziej.',
  'adv.rpt.tpl.kunde.name': 'Raport klientów i sprzedaży',
  'adv.rpt.tpl.kunde.desc': 'Rozwój sprzedaży, najwięksi klienci, koncentracja klientów i należności.',
  'adv.rpt.tpl.kostnad.name': 'Raport kosztów',
  'adv.rpt.tpl.kostnad.desc': 'Rozwój kosztów, najwięksi dostawcy i dowody księgowe bez dokumentacji.',
  'adv.rpt.tpl.utestaende.name': 'Otwarte pozycje',
  'adv.rpt.tpl.utestaende.desc': 'Nieopłacone pozycje klientów i dostawców w podziale na przeterminowane i niewymagalne.',
  'adv.rpt.tpl.arsoppsummering.name': 'Podsumowanie roku',
  'adv.rpt.tpl.arsoppsummering.desc': 'Podsumowuje cały rok — wynik, bilans, sprzedaż, koszty i ryzyka.',
  'adv.rpt.length.2to3': '2–3 strony',
  'adv.rpt.length.2to4': '2–4 strony',
  'adv.rpt.length.3to5': '3–5 stron',
  'adv.rpt.length.4to6': '4–6 stron',
  'adv.rpt.length.8to12': '8–12 stron',
  'adv.rpt.length.variable': 'Zakres zależy od dostępnych danych',
  'adv.rpt.length.10to14': '10–14 stron',
  'adv.rpt.doc.contents': 'Spis treści',
  'adv.rpt.doc.brand': 'PLUMME / AI DORADCA',
  'adv.rpt.doc.continued': 'cd.',
  'adv.rpt.doc.back': 'Wstecz',
  'adv.rpt.doc.draft': 'Szkic',
  'adv.rpt.doc.saved': 'Zapisano',
  'adv.rpt.doc.save': 'Zapisz',
  'adv.rpt.doc.savedToast': 'Raport został zapisany.',
  'adv.rpt.doc.exportPdf': 'Eksportuj PDF',
  'adv.rpt.doc.exportPptx': 'Pobierz PowerPoint',
  'adv.rpt.doc.exportingPptx': 'Tworzenie pliku PowerPoint …',
  'adv.rpt.doc.exportPptxFailed': 'Nie udało się utworzyć pliku PowerPoint. Spróbuj ponownie.',
  'adv.rpt.doc.presentation': 'PREZENTACJA',
  'adv.rpt.doc.coverFoot': 'Wygenerowano z danych raportu w Plumme',
  'adv.rpt.doc.exporting': 'Tworzenie PDF …',
  'adv.rpt.doc.exportFailed': 'Nie udało się utworzyć pliku raportu. Spróbuj ponownie.',
  'adv.rpt.doc.period': '{year} · miesiące roku: {months}',
  'adv.rpt.doc.createTask': 'Utwórz zadanie',
  'adv.rpt.doc.taskCreated': 'Dodano do centrum działań z przypomnieniem {date}.',
  'adv.rpt.doc.taskFailed': 'Nie udało się utworzyć zadania.',
  'adv.rpt.doc.taskNote': 'Utworzono z: {report}.',
  'adv.rpt.narr.section': 'Podsumowanie od SuperPlumma',
  'adv.rpt.narr.tag': 'Napisane przez SuperPlumma',
  'adv.rpt.narr.idle': 'Pozwól SuperPlumma przeczytać raport i napisać podsumowanie: o co toczy się gra, co faktycznie się zmieniło i co warto zrobić teraz.',
  'adv.rpt.narr.write': 'Napisz podsumowanie',
  'adv.rpt.narr.rewrite': 'Napisz ponownie',
  'adv.rpt.narr.loading': 'SuperPlumma czyta raport …',
  'adv.rpt.narr.failed': 'Nie udało się napisać podsumowania. Dane w raporcie i tak są kompletne.',
  'adv.rpt.narr.drivers': 'Co się zmieniło',
  'adv.rpt.narr.watch': 'Co warto obserwować',
  'adv.rpt.narr.nextStep': 'Następny krok: ',
  'adv.rpt.narr.foot': 'Podsumowanie powstało na podstawie danych w raporcie. Wszystkie kwoty są sprawdzane z raportem przed wyświetleniem tekstu.',
  'adv.rpt.sec.changeSince': 'Zmiany od poprzedniego raportu',
  'adv.rpt.col.lastReport': 'Poprzedni raport',
  'adv.rpt.col.now': 'Teraz',
  'adv.rpt.col.change': 'Zmiana',
  'adv.rpt.note.changeSinceBasis': 'W porównaniu z raportem zapisanym {date}. Jego dane są migawką i nie zmieniają się później.',
  'adv.rpt.empty.noPreviousReport': 'To pierwszy zapisany raport tego typu za ten rok. Następnym razem ta sekcja pokaże, co zmieniło się od teraz.',
  'adv.rpt.empty.noComparableReport': 'Poprzedni raport nie zawiera kluczowych danych do porównania.',
  'adv.rpt.sec.summary': 'Podsumowanie',
  'adv.rpt.sec.events': 'Istotne zdarzenia',
  'adv.rpt.sec.keyFigures': 'Kluczowe dane finansowe',
  'adv.rpt.sec.budget': 'Wynik względem budżetu',
  'adv.rpt.sec.liquidity': 'Płynność i zobowiązania płatnicze',
  'adv.rpt.sec.forecast': 'Bieżące saldo w ciągu roku',
  'adv.rpt.sec.balance': 'Bilans i stabilność finansowa',
  'adv.rpt.sec.resultTrend': 'Rozwój wyniku',
  'adv.rpt.sec.sales': 'Rozwój sprzedaży i klientów',
  'adv.rpt.sec.customerChange': 'Lojalność klientów i czas płatności',
  'adv.rpt.sec.costTrend': 'Rozwój kosztów',
  'adv.rpt.sec.suppliers': 'Najwięksi dostawcy',
  'adv.rpt.sec.voucherReview': 'Dowody księgowe do przeglądu',
  'adv.rpt.sec.receivables': 'Pozycje klientów',
  'adv.rpt.sec.payables': 'Pozycje dostawców',
  'adv.rpt.sec.risk': 'Ryzyka i niepewności',
  'adv.rpt.sec.actions': 'Zalecane działania',
  'adv.rpt.sec.decisions': 'Sprawy do decyzji',
  'adv.rpt.sec.dataBasis': 'Źródła danych',
  'adv.rpt.sec.bridge': 'Co wpłynęło na wynik',
  'adv.rpt.sec.workingCapital': 'Kapitał obrotowy i czas zamrożenia środków',
  'adv.rpt.sec.rolling': 'Kroczące 12 miesięcy',
  'adv.rpt.col.driver': 'Czynnik',
  'adv.rpt.col.effect': 'Efekt',
  'adv.rpt.col.priority': 'Priorytet',
  'adv.rpt.bridge.opening': 'Wynik {year}',
  'adv.rpt.bridge.closing': 'Wynik {year}',
  'adv.rpt.bridge.revenue': 'Zmiana przychodów',
  'adv.rpt.bridge.finance': 'Zmiana wyniku finansowego',
  'adv.rpt.bridge.other': 'Pozostałe pozycje (liczba linii: {count})',
  'adv.rpt.bridge.readGuide': 'Czytaj od lewej: zacznij od wyniku z zeszłego roku. Zielony podnosi wynik, czerwony go obniża. Ostatni słupek to wynik tego roku. Kwoty poniżej pokazują każdy wkład.',
  'adv.rpt.bridge.readShort': 'Od zeszłego roku do teraz · Zielony podnosi wynik · Czerwony obniża',
  'adv.rpt.note.bridgeBasis': 'Linie o wpływie poniżej {amount} zostały połączone. Most prowadzi od wyniku za {year} do wyniku w tym roku, a suma czynników to cała zmiana.',
  'adv.rpt.empty.noBridgeBasis': 'Bez zaksięgowanych danych za {year} nie można rozbić zmiany na czynniki.',
  'adv.rpt.empty.noBridgeChange': 'Wynik nie zmienił się względem {year}.',
  'adv.rpt.metric.receivableDays': 'Należności od klientów',
  'adv.rpt.metric.payableDays': 'Zobowiązania wobec dostawców',
  'adv.rpt.metric.capitalGap': 'Czas zamrożenia netto',
  'adv.rpt.metric.measuredPaymentDays': 'Rzeczywisty czas płatności',
  'adv.rpt.metric.netCapitalTied': 'Zamrożony kapitał netto',
  'adv.rpt.note.capitalGapPositive': 'Czekasz na pieniądze o {days} dni dłużej, niż sam potrzebujesz na zapłatę. W tym okresie działalność musi być finansowana z własnej kasy.',
  'adv.rpt.note.capitalGapNegative': 'Płacisz później, niż otrzymujesz zapłatę. Kredyt kupiecki od dostawców finansuje wtedy część działalności.',
  'adv.rpt.note.capitalGapUnknown': 'Nie można obliczyć czasu zamrożenia netto, ponieważ brakuje podstawy przychodów lub kosztów.',
  'adv.rpt.note.workingCapitalBasis': 'Dni należności i zobowiązań to szacunki oparte na otwartych pozycjach i {months} miesiącach roku sprawozdawczego. Rzeczywisty czas płatności mierzy się tylko na opłaconych fakturach dla klientów, więc nie jest to to samo obliczenie.',
  'adv.rpt.empty.noWorkingCapital': 'Brak otwartych pozycji klientów lub dostawców, na których można zmierzyć czas zamrożenia.',
  'adv.rpt.cell.vsPrevious12': 'wobec poprzednich 12',
  'adv.rpt.note.rollingBasis': 'Okno obejmuje ostatnie zaksięgowane miesiące (liczba: {months}), więc porównanie przekracza przełom roku i nie jest zaburzone sezonowością.',
  'adv.rpt.note.noRollingComparison': 'Brak wystarczającej historii, aby porównać z poprzednimi 12 miesiącami.',
  'adv.rpt.empty.noRollingBasis': 'Za mało zaksięgowanej historii, aby zbudować kroczące okno 12-miesięczne.',
  'adv.rpt.certainty.planned': 'Planowane',
  'adv.rpt.summary.profit': 'Po {months} mies. roku {year} zaksięgowano {income} przychodów i zysk w wysokości {result}.',
  'adv.rpt.summary.loss': 'Po {months} mies. roku {year} zaksięgowano {income} przychodów i stratę w wysokości {result}.',
  'adv.rpt.summary.margin': 'Daje to marżę zysku w wysokości {margin} %.',
  'adv.rpt.kpi.income': 'Przychody',
  'adv.rpt.kpi.costs': 'Koszty',
  'adv.rpt.kpi.result': 'Wynik',
  'adv.rpt.kpi.margin': 'Marża zysku',
  'adv.rpt.kpi.revenue': 'Zafakturowana sprzedaż',
  'adv.rpt.kpi.invoiceCount': 'Liczba faktur',
  'adv.rpt.kpi.avgInvoice': 'Średnio na fakturę',
  'adv.rpt.kpi.customerCount': 'Liczba klientów',
  'adv.rpt.metric.receivables': 'Należne od klientów',
  'adv.rpt.metric.payables': 'Należne dostawcom',
  'adv.rpt.metric.buffer': 'Bufor płynności',
  'adv.rpt.metric.lowestBalance': 'Najniższe saldo w roku',
  'adv.rpt.metric.assets': 'Suma aktywów',
  'adv.rpt.metric.equityAndDebt': 'Suma kapitału własnego i zobowiązań',
  'adv.rpt.metric.solidity': 'Udział kapitału własnego',
  'adv.rpt.metric.repeatRate': 'Udział powracających klientów',
  'adv.rpt.metric.avgPaymentDays': 'Średni czas płatności',
  'adv.rpt.unit.days': 'Dni: {days}',
  'adv.rpt.col.line': 'Linia',
  'adv.rpt.col.account': 'Konto',
  'adv.rpt.col.budgetToDate': 'Budżet narastająco',
  'adv.rpt.col.actual': 'Zaksięgowano',
  'adv.rpt.col.variance': 'Odchylenie',
  'adv.rpt.col.month': 'Miesiąc',
  'adv.rpt.col.in': 'Wpływy',
  'adv.rpt.col.out': 'Wypływy',
  'adv.rpt.col.balance': 'Saldo',
  'adv.rpt.col.certainty': 'Podstawa',
  'adv.rpt.col.income': 'Przychody',
  'adv.rpt.col.costs': 'Koszty',
  'adv.rpt.col.result': 'Wynik',
  'adv.rpt.col.share': 'Udział',
  'adv.rpt.chart.budgetActual': 'Budżet a zaksięgowane narastająco',
  'adv.rpt.chart.monthlyResult': 'Wynik miesięczny',
  'adv.rpt.chart.incomeCosts': 'Przychody i koszty w poszczególnych miesiącach',
  'adv.rpt.chart.summaryResult': 'Od przychodów do wyniku',
  'adv.rpt.chart.keyFiguresComparison': 'Kluczowe dane wobec zeszłego roku',
  'adv.rpt.chart.previousPeriod': 'Poprzedni okres',
  'adv.rpt.chart.currentPeriod': 'Bieżący okres',
  'adv.rpt.chart.cumulativeResult': 'Wynik narastająco w ciągu roku',
  'adv.rpt.chart.runningBalance': 'Saldo bieżące i bufor płynności',
  'adv.rpt.chart.openItemsDue': 'Otwarte pozycje według terminu',
  'adv.rpt.chart.workingCapitalGap': 'Kapitał zamrożony w otwartych pozycjach',
  'adv.rpt.chart.balanceBasis': 'Zaksięgowane grupy bilansowe',
  'adv.rpt.chart.bookedBalance': 'Zaksięgowane saldo',
  'adv.rpt.chart.capitalStructure': 'Struktura kapitału',
  'adv.rpt.chart.equityShare': 'Kapitał własny',
  'adv.rpt.chart.otherFinancing': 'Inne finansowanie',
  'adv.rpt.chart.profit': 'Zysk',
  'adv.rpt.chart.loss': 'Strata',
  'adv.rpt.col.amount': 'Kwota',
  'adv.rpt.col.changeYoy': 'Zmiana wobec zeszłego roku',
  'adv.rpt.col.status': 'Status',
  'adv.rpt.row.income': 'Przychody',
  'adv.rpt.row.costs': 'Koszty',
  'adv.rpt.row.notDue': 'Niewymagalne',
  'adv.rpt.row.current': 'Niewymagalne',
  'adv.rpt.row.overdue': 'Przeterminowane',
  'adv.rpt.row.total': 'Suma',
  'adv.rpt.cell.vsPreviousYear': 'wobec zeszłego roku',
  'adv.rpt.cell.noBasis': 'Brak porównania',
  'adv.rpt.month.jan': 'Styczeń',
  'adv.rpt.month.feb': 'Luty',
  'adv.rpt.month.mar': 'Marzec',
  'adv.rpt.month.apr': 'Kwiecień',
  'adv.rpt.month.may': 'Maj',
  'adv.rpt.month.jun': 'Czerwiec',
  'adv.rpt.month.jul': 'Lipiec',
  'adv.rpt.month.aug': 'Sierpień',
  'adv.rpt.month.sep': 'Wrzesień',
  'adv.rpt.month.oct': 'Październik',
  'adv.rpt.month.nov': 'Listopad',
  'adv.rpt.month.dec': 'Grudzień',
  'adv.rpt.certainty.confirmed': 'Zaksięgowano',
  'adv.rpt.certainty.expected': 'Bieżący miesiąc',
  'adv.rpt.certainty.uncertain': 'Jeszcze nie zaksięgowano',
  'adv.rpt.budget.intro': 'Zaksięgowane dane za {months} mies. roku {year} porównano z budżetem na te same miesiące, a nie z budżetem na cały rok.',
  'adv.rpt.vouchers.missing': 'Zaksięgowane zakupy bez dowodu księgowego: {count}. Łącznie dotyczy to {net} podstawy i {vat} odliczonego VAT.',
  'adv.rpt.action.impact': '{label}: {value}',
  'adv.rpt.priority.high': 'Wysoki',
  'adv.rpt.priority.medium': 'Średni',
  'adv.rpt.priority.low': 'Niski',
  'adv.rpt.severity.critical': 'Krytyczne',
  'adv.rpt.severity.watch': 'Wymaga monitorowania',
  'adv.rpt.severity.info': 'Do wiadomości',
  'adv.rpt.decision.risk': 'Podejmij decyzję: {name}',
  'adv.rpt.decision.opportunity': 'Rozważ: {name}',
  'adv.rpt.decision.freeCapital': 'Zdecyduj o wykorzystaniu wolnego kapitału w wysokości {amount}.',
  'adv.rpt.note.noPreviousYear': 'Brak zaksięgowanych danych za {year}, więc nie można obliczyć zmiany wobec zeszłego roku.',
  'adv.rpt.note.partialYear': 'Okres nie jest zamknięty. Dane obejmują {months} mies. roku {year}.',
  'adv.rpt.note.noMaterialVariance': 'Żadna pojedyncza linia nie odbiega istotnie od budżetu.',
  'adv.rpt.note.unbudgeted': 'Konta z zaksięgowanymi kwotami bez linii budżetowej: {count}. Uwzględniono je w sumie.',
  'adv.rpt.note.belowBuffer': 'Najniższe obliczone saldo wynosi {lowest} i jest poniżej wybranego celu bufora {buffer}.',
  'adv.rpt.note.aboveBuffer': 'Saldo bieżące utrzymuje się powyżej bufora {buffer} przez cały okres.',
  'adv.rpt.note.forecastIsBooked': 'Krzywa to saldo bieżące zaksięgowanych danych, a nie model prognozy. Miesiące bez księgowań pozostają płaskie.',
  'adv.rpt.note.balanceGrouping': 'Kapitał własny i zobowiązania są pokazane razem, tak jak grupuje je zestawienie obrotów i sald.',
  'adv.rpt.note.balanceInterimBasis': 'Grupy bilansowe są pokazane tak, jak zaksięgowano je na dzień raportu. Różnica między stronami może obejmować wynik okresu i nie należy jej traktować jako gotowego bilansu rocznego.',
  'adv.rpt.note.noCustomerSplit': 'Sprzedaż nie jest podzielona na klientów w danych źródłowych.',
  'adv.rpt.note.concentration': '{name} odpowiada za {pct} % zafakturowanej sprzedaży.',
  'adv.rpt.note.customerBasis': 'Czas płatności jest mierzony na fakturach, które faktycznie zostały opłacone.',
  'adv.rpt.note.costJump': 'Co najmniej jedna linia kosztów wzrosła o ponad 25 % wobec zeszłego roku.',
  'adv.rpt.note.topFiveOnly': 'Pokazano pięć największych. Pozostałe są ujęte w sumach, ale niewymienione.',
  'adv.rpt.note.vouchersComplete': 'Wszystkie zaksięgowane zakupy mają dowód księgowy.',
  'adv.rpt.note.vouchersRequired': 'Bokføringsloven wymaga dokumentacji każdego księgowania. Brakujące dowody księgowe należy uzyskać przed zgłoszeniem okresu.',
  'adv.rpt.note.overdueSales': '{amount} jest przeterminowane od klientów i wymaga działań.',
  'adv.rpt.note.overduePurchases': '{amount} jest przeterminowane wobec dostawców.',
  'adv.rpt.note.noRisks': 'W zaksięgowanych danych nie znaleziono ryzyk.',
  'adv.rpt.note.noActions': 'Obecnie nie zaleca się żadnych działań.',
  'adv.rpt.note.notAProtocol': 'To wsparcie decyzyjne, które nie zastępuje protokołu zarządu. Uchwały podejmuje zarząd.',
  'adv.rpt.empty.noBookkeeping': 'Za {year} nie zaksięgowano przychodów ani kosztów. Raport otrzyma dane, gdy tylko pojawią się dowody księgowe.',
  'adv.rpt.empty.noEvents': 'W okresie nie zarejestrowano istotnych zmian.',
  'adv.rpt.empty.noBudget': 'Brak budżetu na {year}. Wprowadź budżet, aby zobaczyć odchylenia w raporcie.',
  'adv.rpt.empty.noLiquidityBasis': 'Brak otwartych pozycji klientów lub dostawców i brak zaksięgowanych ruchów, na których można oprzeć saldo.',
  'adv.rpt.empty.noForecast': 'Brak uzgodnionej podstawy środków pieniężnych dla krzywej salda.',
  'adv.rpt.empty.noBalance': 'Zestawienie obrotów i sald za {year} jest puste.',
  'adv.rpt.empty.noSales': 'Brak zaksięgowanej zafakturowanej sprzedaży za {year}.',
  'adv.rpt.empty.noCustomerHistory': 'Za mało historii klientów, aby zmierzyć ponowne zakupy i czas płatności.',
  'adv.rpt.empty.noCosts': 'Brak zaksięgowanych kosztów za {year}.',
  'adv.rpt.empty.noSupplierSplit': 'Koszty nie są podzielone według dostawców w danych źródłowych.',
  'adv.rpt.empty.noReceivables': 'Brak nierozliczonych pozycji klientów.',
  'adv.rpt.empty.noPayables': 'Brak nierozliczonych pozycji dostawców.',
  'adv.rpt.empty.noDecisions': 'Obecnie żadne sprawy nie wymagają decyzji.',
  'adv.rpt.source.result': 'Rachunek zysków i strat',
  'adv.rpt.source.balance': 'Zestawienie obrotów i sald',
  'adv.rpt.source.openItems': 'Otwarte pozycje klientów i dostawców',
  'adv.rpt.source.budget': 'Budżet',
  'adv.rpt.source.bank': 'Ruchy bankowe',
  'adv.rpt.source.invoices': 'Faktury sprzedaży',
  'adv.rpt.source.purchases': 'Faktury od dostawców',
  'adv.rpt.source.vouchers': 'Dowody księgowe',
  'adv.rpt.basis.generated': 'Wygenerowano {date}.',
  'adv.rpt.basis.period': 'Okres obejmuje miesiące roku {year}: {months}.',
  'adv.rpt.basis.noPreviousYear': 'Brak zaksięgowanych danych za {year} — brak porównania z poprzednim rokiem.',
  'adv.rpt.basis.noBudget': 'Brak pozycji budżetu za {year}.',
  'adv.rpt.basis.noPartySplit': 'Podział według klientów i dostawców jest niepełny. Przegląd klientów pokazuje kwoty, które można powiązać z zafakturowaną sprzedażą.',
  'adv.rpt.basis.topFive': 'Listy klientów i dostawców pokazują pięciu największych.',
  'adv.rpt.basis.bookedOnly': 'Dane księgowe pochodzą z ksiąg. Bufor jest celem, a nie zaksięgowanym saldem. Planowane płatności i wyliczone wskaźniki są oznaczone w raporcie.',
  'adv.rpt.period.monthShort': '{month}/{year}',
  'adv.rpt.period.vsPreviousMonth': 'względem poprzedniego miesiąca',
  'adv.rpt.monthPicker.title': 'Wybierz miesiąc raportu miesięcznego',
  'adv.rpt.monthPicker.intro': 'Wybierz jeden z ostatnich 24 miesięcy kalendarzowych. Raport korzysta tylko z zaksięgowanych danych, budżetu i porównań dla wybranego miesiąca.',
  'adv.rpt.monthPicker.separate': 'Raport miesięczny ma własny wybór miesiąca i nie zależy od wyboru roku lub kwartału w innych raportach.',
  'adv.rpt.monthPicker.continue': 'Wybierz miesiąc',
  'adv.rpt.monthPicker.back': 'Wróć do szablonów raportów',
  'adv.rpt.monthPicker.generate': 'Wygeneruj raport miesięczny',
  'adv.rpt.sec.monthlyStatus': 'Stan za miesiąc',
  'adv.rpt.sec.monthlyBudget': 'Miesiąc względem budżetu',
  'adv.rpt.sec.monthlyComparison': 'Ten sam miesiąc rok temu',
  'adv.rpt.sec.monthlyTrend': 'Rozwój w ostatnich 12 miesiącach',
  'adv.rpt.sec.monthlyInsights': 'Ocena miesiąca i kolejne kroki',
  'adv.rpt.empty.noMonthlyBudget': 'Brak budżetu dla wybranego miesiąca.',
  'adv.rpt.empty.noMonthlyComparison': 'Brak zaksięgowanych danych za ten sam miesiąc rok temu.',
  'adv.rpt.empty.noMonthlyTrend': 'Brak zaksięgowanych danych miesięcznych w oknie dwunastu miesięcy.',
  'adv.rpt.col.budget': 'Budżet',
  'adv.rpt.col.variancePct': 'Odchylenie w %',
  'adv.rpt.row.result': 'Wynik',
  'adv.rpt.chart.monthBudgetActual': 'Budżet i wykonanie za miesiąc',
  'adv.rpt.chart.sameMonthComparison': 'Wybrany miesiąc względem tego samego miesiąca rok temu',
  'adv.rpt.metric.averageMonthlyResult': 'Średni wynik miesięczny',
  'adv.rpt.metric.bestMonthlyResult': 'Najlepszy miesiąc',
  'adv.rpt.metric.weakestMonthlyResult': 'Najsłabszy miesiąc',
  'adv.rpt.monthly.statusProfit': 'Miesiąc zakończył się zyskiem {result} i marżą wyniku {margin} %.',
  'adv.rpt.monthly.statusLoss': 'Miesiąc zakończył się stratą {result} i marżą wyniku {margin} %.',
  'adv.rpt.monthly.budgetAbove': 'Wynik jest o {amount} lepszy od budżetu na ten miesiąc.',
  'adv.rpt.monthly.budgetBelow': 'Wynik jest o {amount} słabszy od budżetu na ten miesiąc.',
  'adv.rpt.monthly.marginChange': 'Marża wyniku zmieniła się o {change} pkt proc. względem tego samego miesiąca rok temu.',
  'adv.rpt.monthly.trendBasis': 'Rozwój pokazuje do 12 zaksięgowanych miesięcy kalendarzowych do wybranego miesiąca włącznie.',
  'adv.rpt.monthly.insightLossTitle': 'Ujemny wynik miesięczny',
  'adv.rpt.monthly.insightLossBody': 'W wybranym miesiącu koszty przewyższyły przychody o {amount}.',
  'adv.rpt.monthly.insightProfitTitle': 'Dodatni wynik miesięczny',
  'adv.rpt.monthly.insightProfitBody': 'Miesiąc przyniósł zysk {amount}. Sprawdź, które przychody i koszty warto powtórzyć.',
  'adv.rpt.monthly.insightIncomeDownTitle': 'Niższe przychody niż rok temu',
  'adv.rpt.monthly.insightIncomeDownBody': 'Przychody są o {change} % niższe niż w tym samym miesiącu rok temu.',
  'adv.rpt.monthly.insightCostsTitle': 'Koszty powyżej budżetu',
  'adv.rpt.monthly.insightCostsBody': 'Koszty są o {amount} wyższe od budżetu na ten miesiąc.',
  'adv.rpt.monthly.insightBudgetTitle': 'Wynik poniżej budżetu',
  'adv.rpt.monthly.insightBudgetBody': 'Wynik jest o {amount} słabszy od budżetu na ten miesiąc.',
  'adv.rpt.monthly.stepReviewDrivers': 'Przejrzyj pozycje wyjaśniające wynik miesiąca i ustal, co jest trwałe.',
  'adv.rpt.monthly.stepRevenue': 'Przeanalizuj spadek przychodów względem tego samego miesiąca rok temu.',
  'adv.rpt.monthly.stepCosts': 'Wskaż koszty, które przekraczają budżet miesięczny.',
  'adv.rpt.monthly.stepBudget': 'Zaktualizuj działania, aby zamknąć odchylenie wyniku od budżetu miesięcznego.',
  'adv.rpt.monthly.stepContinue': 'Utrzymaj czynniki stojące za dodatnim wynikiem miesiąca i obserwuj rozwój w kolejnym miesiącu.',
});
